<template>
  <span
    >Welcome to <b>HL7 - HAPI FHIR</b></span
  >
</template>

<script>
export default {
  name: "notification-template",
};
</script>
